import Fetch, { V1 } from 'Util/fetcher';

const ON_REQUEST_SIMULATOR = 'ON_REQUEST_SIMULATOR';
const ON_REQUEST_SIMULATOR_FAILURE = 'ON_REQUEST_SIMULATOR_FAILURE';
const ON_REQUEST_SIMULATOR_SUCCESS = 'ON_REQUEST_SIMULATOR_SUCCESS';

function onRequestSimulator() {
  return {
    type: ON_REQUEST_SIMULATOR,
  };
}

function onRequestSimulatorSuccess(payload) {
  return {
    type: ON_REQUEST_SIMULATOR_SUCCESS,
    payload,
  };
}

function onRequestSimulatorFailure(payload) {
  return {
    type: ON_REQUEST_SIMULATOR_FAILURE,
    payload,
  };
}

export const onDoRequestSimulator = () => (dispatch) => {
  dispatch(onRequestSimulator());
  Fetch.get(`${V1}funds/category-simulator`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestSimulatorSuccess(resp.json));
      } else {
        dispatch(onRequestSimulatorFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestSimulatorFailure(error.message));
    });
};

const INITIAL_STATE = {
  simulatorLoading: false,
  simulatorData: null,
  simulatorError: null,
};

const simmulator = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_REQUEST_SIMULATOR:
      return {
        ...state,
        simulatorLoading: true,
        simulatorData: null,
        simulatorError: null,
      };
    case ON_REQUEST_SIMULATOR_SUCCESS:
      return {
        ...state,
        simulatorLoading: false,
        simulatorData: action.payload,
        simulatorError: null,
      };
    case ON_REQUEST_SIMULATOR_FAILURE:
      return {
        ...state,
        simulatorLoading: false,
        simulatorData: null,
        simulatorError: action.payload,
      };
    default:
      return state;
  }
};

export default simmulator;
